<template>
    <div class="learning" v-if="course">
        <div v-if="isOutOfBounds">
            <div class="container pt-3 pb-3 text-center">
                Невалиден въпрос
            </div>
        </div>
        <div v-else>
            <questions-toolbar
                :current-question="currentQuestion"
                :total-questions="totalQuestions"
                :has-prev="true"
                @prev="prevQuestion()"
                :has-next="true"
                @next="nextQuestion(false)"
                :allowed-questions="totalQuestions"
                @navigateToQuestion="navigateToQuestion"
                @back="$router.push({ name: 'course', params: { course: course.id } })"
            >
                <template v-slot:nav>
                    <a @click="openSettingsPopup" style="cursor: pointer">
                        <span class="bi bi-gear-fill"></span>
                    </a>
                </template>
            </questions-toolbar>

            <div class="question-wrapper">
                <span class="question-swiper-arrow-left bi bi-arrow-left" v-if="arrowsVisible"></span>
                <span class="question-swiper-arrow-right bi bi-arrow-right" v-if="arrowsVisible"></span>

                <div class="question-swiper">
                    <swiper
                        :slides-per-view="1"
                        @setTranslate="setSwiperTranslate"
                        @touchStart="onSwiperTouchStart"
                        @touchEnd="onSwiperTouchEnd"
                        @transitionEnd="onSwiperTransitionEnd"
                        :options="swiperOptions"
                    >
                        <swiper-slide>
                            <question
                                :question="question"
                                @selectedAnswer="setAnswer"
                                :answer-state="answerState"
                                :disabled="disabled"
                                :random-answers="randomAnswers"
                                ref="question"
                                :topic="topic"
                                :subject="subject"
                            />
                        </swiper-slide>
                    </swiper>
                </div>
            </div>

        </div>

        <div class="footer">
            <router-link :to="{ name: 'course', params: { course: course.id } }">
                <img src="/img/logo.png" alt="kapitani.bg logo" class="logo">
            </router-link>
        </div>

        <div class="modal" id="settings-modal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-body">
                        <div style="margin-top: -5px;">
                            <label class="custom-control custom-switch custom-switch-md" style="padding-top: 5px; padding-bottom: 5px; margin-bottom: 0">
                                <input class="custom-control-input"  type="checkbox" id="random-questions" v-model="randomQuestionsInput">
                                <div class="custom-control-label" for="random-questions" style="width: 100%">Разбъркани въпроси</div>
                            </label>

                            <label class="custom-control custom-switch custom-switch-md" style="padding-top: 5px; padding-bottom: 5px; margin-bottom: 0">
                                <input class="custom-control-input"  type="checkbox" id="random-answers" v-model="randomAnswersInput">
                                <div class="custom-control-label" style="width: 100%">Разбъркани отговори</div>
                            </label>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-block btn-lg btn-primary" @click="saveSettings">Запази</button>
                        <button type="button" class="btn btn-block btn-lg btn-light" data-dismiss="modal">Отказ</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Repository from '../../services/Repository';
    import jQuery from 'jquery';
    import courses from '../../data/courses';

    let latestAnsweredQuestions = {};

    export default {

        data() {
            return {
                currentQuestion: 1,
                currentAnswer: null,
                disabled: false,
                randomQuestions: false,
                randomAnswers: false,
                randomQuestionsInput: false,
                randomAnswersInput: false,
                topicIds: [],
                latestAnsweredQuestions: {},
                course: null,
                isSwiperMoving: false,
                swiperTranslation: 0,
                arrowsVisible: false,
            }
        },

        computed: {
            swiperOptions() {
                return {
                    edgeSwipeDetection: 'prevent',
                    // passiveListeners: false,
                };
            },

            questions() {
                return this.course ? this.course.getQuestionsByTopicIds(this.topicIds) : [];
            },

            totalQuestions() {
                return this.questions.length;
            },

            question() {
                return this.questions[this.currentQuestion - 1];
            },

            answerState() {
                if (!this.currentAnswer) {
                    return null;
                }

                return this.currentAnswer.isCorrect ? 'correct' : 'wrong';
            },

            isOutOfBounds() {
                return isNaN(this.currentQuestion) ||
                    this.currentQuestion > this.questions.length;
            },

            topic() {
                return this.course && this.question ? this.course.findTopic(this.question.topicId): null;
            },

            subject() {
                return this.course && this.question ? this.course.findSubject(this.question.subjectId): null;
            },
        },

        methods: {
            onSwiperTouchStart() {
                this.isSwiperMoving = true;
                this.arrowsVisible = true;
            },
            onSwiperTouchEnd() {
                this.isSwiperMoving = false;

                if (this.swiperTranslation > -10 && this.swiperTranslation < 10) {
                    this.arrowsVisible = false;
                }
            },
            onSwiperTransitionEnd() {
                let translation = this.swiperTranslation;
                this.swiperTranslation = 0;
                this.arrowsVisible = false;

                if (translation > 60) {
                    this.prevQuestion();
                }

                if (translation < -60) {
                    this.nextQuestion(false)
                }
            },
            setSwiperTranslate(swiper, translation) {
                if (this.isSwiperMoving) {
                    this.swiperTranslation = translation;
                }
            },
            prevQuestion() {
                let question = null;

                if (this.currentQuestion - 1 < 1) {
                    question = this.questions.length;
                }
                else {
                    question = this.currentQuestion - 1;
                }

                this.$router.push({
                    name: 'learning',
                    params: {
                        course: this.course.id,
                        question: question,
                    }
                });
            },

            nextQuestion(random = true) {
                let question = null;

                if (random && this.randomQuestions) {
                    question = this.pickRandomQuestion()
                }
                else if (this.currentQuestion + 1 > this.questions.length) {
                    question = 1;
                }
                else {
                    question = this.currentQuestion + 1;
                }

                this.$router.push({
                    name: 'learning',
                    params: {
                        course: this.course.id,
                        question,
                    }
                });
            },

            reset() {
                this.currentAnswer = null;
                this.disabled = false;
                if (this.$refs.question) {
                    this.$refs.question.resetCurrentAnswer();
                }
            },

            setAnswer(answer) {
                this.currentAnswer = answer;

                if (answer.isCorrect) {
                    this.disabled = true;

                    if (latestAnsweredQuestions[this.question.id]) {
                        latestAnsweredQuestions[this.question.id] = latestAnsweredQuestions[this.question.id] + 1;
                    }
                    else {
                        latestAnsweredQuestions[this.question.id] = 1;
                    }

                    setTimeout(() => this.nextQuestion(), 1000);
                }
            },

            setCurrentQuestion(currentQuestion) {
                this.currentQuestion = parseInt(currentQuestion, 10);
                Repository.setLatestLearningQuestion(this.course.id, this.currentQuestion);
                this.reset();
            },

            navigateToQuestion(question) {
                this.$router.push({
                    name: 'learning',
                    params: {
                        course: this.course.id,
                        question,
                    }
                });
            },

            openSettingsPopup() {
                this.randomQuestionsInput = this.randomQuestions;
                this.randomAnswersInput = this.randomAnswers;

                jQuery('#settings-modal').modal('show');
            },

            pickRandomQuestion() {
                let minValue = Math.min.apply(this, Object.values(latestAnsweredQuestions));
                let arr = [];

                for (let id in latestAnsweredQuestions) {
                    if (latestAnsweredQuestions[id] == minValue) {
                        arr.push(id);
                    }
                }

                let randomId = arr.sort(() => 0.5 - Math.random())[0];
                let index = 1;

                for (let questionKey in this.questions) {
                    if (this.questions[questionKey].id == randomId) {
                        return index;
                    }

                    index++;
                }

                return index;
            },

            saveSettings() {
                Repository.setLearningRandomQuestion(this.randomQuestionsInput);
                Repository.setLearningRandomAnswers(this.randomAnswersInput);

                jQuery('#settings-modal').modal('hide');

                this.randomQuestions = this.randomQuestionsInput;
                this.randomAnswers = this.randomAnswersInput;
            },

            setCurrentCourse(id) {
                this.course = courses.find(course => parseInt(course.id, 10) === parseInt(id, 10))
            },

            init(courseId, question) {
                this.setCurrentCourse(courseId);
                let topicIds = Repository.loadLearningTopics(courseId);
                this.$set(this, 'topicIds', topicIds ? topicIds : []);

                latestAnsweredQuestions = {};

                for (let question of this.questions) {
                    latestAnsweredQuestions[question.id] = 0;
                }

                this.randomQuestions = Repository.getLearningRandomQuestion();
                this.randomAnswers = Repository.getLearningRandomAnswers();
                this.randomQuestionsInput = Repository.getLearningRandomQuestion();
                this.randomAnswersInput = Repository.getLearningRandomAnswers();
                this.setCurrentQuestion(question);
            }
        },

        beforeRouteEnter (to, from, next) {
            next(vm => vm.init(to.params.course, to.params.question));
        },

        // when route changes and this component is already rendered,
        // the logic will be slightly different.
        beforeRouteUpdate (to, from, next) {
            this.init(to.params.course, to.params.question);
            next();
        }

    }
</script>